/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_User_SettingsInputs */

const en_nav_user_settings = /** @type {(inputs: Nav_User_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Settings`)
};

const es_nav_user_settings = /** @type {(inputs: Nav_User_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuracion de usuario`)
};

/**
* | output |
* | --- |
* | "User Settings" |
*
* @param {Nav_User_SettingsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_user_settings = /** @type {((inputs?: Nav_User_SettingsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_User_SettingsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_user_settings(inputs)
	return es_nav_user_settings(inputs)
});